import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/assistenza',
            name: 'assistenza',
            component: () => import("./views/assistenza.vue"),
            meta: {
                hasBar: true
            }
        },
        {
            path: '/assistenza/:identifier',
            name: 'assistenzaDetail',
            component: () => import("@/views/chat/views/chatDetail.vue"),
            // component: () => import("./views/assistenzaDetail.vue"),
        },
        {
            path: '/assistenza/new/:subject?',
            name: 'assistenzaNew',
            component: () => import("./views/assistenzaNew.vue"),
        },
    ];
};